import { render, staticRenderFns } from "./ApiSocket.vue?vue&type=template&id=fb43a1ec&scoped=true&"
import script from "./ApiSocket.vue?vue&type=script&lang=js&"
export * from "./ApiSocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb43a1ec",
  null
  
)

export default component.exports